var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"color":"var(--fb-text-4)","padding":"5px 12px"}},[_vm._v(" "+_vm._s('No options for this module')+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }